import * as React from 'react';
import Typography from "@mui/material/Typography/Typography";
import Stack from "@mui/material/Stack/Stack";
import Box from "@mui/material/Box/Box";
import IconButton from "@mui/material/IconButton/IconButton";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import moment from "moment/moment";
import {saveAs} from "file-saver";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import firebase from "../firebase/firebase";
import LinkTwoToneIcon from '@mui/icons-material/LinkTwoTone';
import axios from "axios";
import Avatar from "@mui/material/Avatar/Avatar";
export default function LinkMessageComponent({msg, type}){
  const [metadata, setMetadata] = React.useState();
  async function testmetadata (){

    try {


      const response = await axios.post(
        'https://api-taost.herokuapp.com/meta-data',
        { url: msg?.text },
        { headers: { 'Content-Type': 'application/json',}  }
      )
      setMetadata(response.data);
      //
    } catch (e) {
      //
      setMetadata()
      console.log(undefined)
    }

  }
  React.useEffect(() => {
    testmetadata()
  }, [msg])
  if (type === 'r') {
    return (

      <Stack direction={'row-reverse'} spacing={1}>
        <Stack direction={'row'} spacing={1} sx={{ p:1, backgroundColor: '#204488',  color: '#fff', borderRadius: '5px', maxWidth:'70%'}} justifyContent="flex-end"
               alignItems="flex-end">
          <Stack direction={'row'} spacing={2} justifyContent="flex-start"
                 alignItems="center">

                {metadata && metadata?.image ? <img src={metadata.image} style={{height: 75, width:75}}/> :
                  <Box sx={{

                    background: '#98989842',
                    borderRadius: '3px',
                    color:'#fff',
                    fontSize:'small',
                    padding: '18px 9px',
                    textTransform:'uppercase'
                  }} ><IconButton  href={msg?.text} target={'_blank'}>  <LinkTwoToneIcon  style={{color: '#4acfee'}}/></IconButton></Box>

                }
            <Stack direction={'column'} sx={{flex: 1}}>
              <Typography variant={'subtitle1'} noWrap={true} sx={{ width:250 }} >
                {metadata && metadata?.title }
              </Typography>

              <Typography variant={'body2'} component={'a'} href={msg?.text} sx={{ flex:1, wordBreak: 'break-all', color: '#fff'}} >
                {metadata && metadata?.description ?  metadata?.description : msg?.text}
              </Typography>
            </Stack>

          </Stack>
          <Stack direction={'row'} spacing={.5}>

            <Typography variant={'caption'}>
              {msg.createdAt && moment(msg.createdAt.seconds * 1000).format('HH:mm')}
            </Typography>

            {msg.read === true ?    <DoneAllOutlinedIcon style={{color: '#4acfee',fontSize: 18}}  /> :<DoneAllOutlinedIcon  style={{color:'#ccc',fontSize: 18}}/>

            }

          </Stack>
        </Stack>
      </Stack>
    )
  } else {
    return (
      <Stack direction={'row'} spacing={1}>
        <Stack direction={'row'} spacing={1} sx={{ p:1, backgroundColor:'#F1F1F1', borderRadius: '5px', maxWidth:'70%'}} justifyContent="flex-end"
               alignItems="flex-end">
          <Stack
            direction={'row'}
                 spacing={2} justifyContent="flex-start"
                 alignItems="center">
            {metadata && metadata?.image ? <img src={metadata.image} style={{height: 75, width:75}}/> :
              <Box sx={{

                background: '#98989842',
                borderRadius: '3px',
                color:'#fff',
                fontSize:'small',
                padding: '18px 9px',
                textTransform:'uppercase'
              }} ><IconButton  href={msg?.text} target={'_blank'}>  <LinkTwoToneIcon  style={{color: '#4acfee'}}/></IconButton></Box>

            }<Stack direction={'column'} sx={{flex: 1}}>
              <Typography variant={'subtitle1'} noWrap={true} sx={{ width:250  }} >
                {metadata && metadata?.title }
              </Typography>

              <Typography variant={'body2'} sx={{ flex:1, wordBreak: 'break-all'}} >
                {msg?.text}
              </Typography>
            </Stack>
          </Stack>

          <Stack direction={'row'} spacing={.5}>

            <Typography variant={'caption'} color={'secondary'}>
              {msg.createdAt && moment(msg.createdAt.seconds * 1000).format('HH:mm')}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    )
  }
}